import React from 'react';
import TrackingService from '@/services/tracking';
import { getAsset } from '@/utils';
import { Box, dimmed, HStack, Icongraphy } from '@design-system/pc';
import { useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { ImgItemType } from './hook/ReserveFormHook';

interface PictureListProps {
  handleAddPictureList: (value: File) => void;
  handleRemovePictureFile: (value: number) => void;
}

const PictureList = ({
  handleAddPictureList,
  handleRemovePictureFile,
}: PictureListProps) => {
  const { watch } = useFormContext();
  return (
    <HStack space={8}>
      {watch('images')?.map((item: ImgItemType) => (
        <Box
          key={`picture-item-${item.seq}`}
          position="relative"
          width="calc(20% - 6px)"
          style={{ aspectRatio: '1/1' }}
        >
          <Picture
            src={item.url || getAsset('/assets/images/no_image.png')}
            onError={({ currentTarget }) => {
              currentTarget.src = getAsset('/assets/images/no_image.png');
            }}
          />
          <Box
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
            top="1px"
            right="1px"
            width="28px"
            height="28px"
            backgroundColor={dimmed.dark.dimmed_50}
            style={{ cursor: 'pointer' }}
            onClick={() => handleRemovePictureFile(item.seq)}
            {...TrackingService.tagGTM(
              'visit_consult_form_picture_remove_button',
            )}
          >
            <Icongraphy
              variant="ic_close_bold"
              size={16}
              resize
              fillColor="#ffffff"
            />
          </Box>
        </Box>
      ))}

      {watch('images').length < 5 && (
        <PictureAddBox as="label">
          <Icongraphy variant="ic_plus" size={36} resize />
          <FileInput
            type={'file'}
            onChange={({ target }) => {
              if (!target.files?.[0]) return;
              handleAddPictureList(target.files?.[0]);
              target.value = '';
            }}
            {...TrackingService.tagGTM('visit_consult_form_picture_add_button')}
            accept=".gif, .jpg, .png"
          />
        </PictureAddBox>
      )}
    </HStack>
  );
};

export default PictureList;

const Picture = styled.img`
  ${({ theme }) => {
    return css`
      display: block;
      object-fit: fill;
      width: 100%;
      height: 100%;
      border: 1px solid ${theme.colors.color_chip.gray[200]};
    `;
  }}
`;

const PictureAddBox = styled(Box)`
  ${({ theme }) => {
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(20% - 6px);
      aspect-ratio: 1/1;
      border: 1px solid ${theme.colors.color_chip.gray[200]};
      cursor: pointer;
    `;
  }}
`;
const FileInput = styled.input`
  display: none;
`;
